import { Link } from "react-router";

import { Card } from "@mui/material";

import { IconName } from "@fortawesome/fontawesome-svg-core";

import { cn } from "@utils/tailwind";

import FaIcon from "./FaIcon";
import { Type } from "./Type";

type Color = "gray" | "amber" | "teal" | "sky" | "purple" | "fuchsia";

const iconColorVariants = {
  gray: "bg-neutral-50 text-neutral-500 group-hover:bg-primary-100 group-hover:text-primary-500",
  amber: "bg-amber-50 text-amber-500 group-hover:bg-amber-100",
  teal: "text-teal-500 bg-teal-50 group-hover:bg-teal-100",
  sky: "bg-sky-50 text-sky-500 group-hover:bg-sky-100",
  purple: "text-purple-500 bg-purple-50 group-hover:bg-purple-100",
  orange: "text-orange-500 bg-orange-50 group-hover:bg-orange-100",
};

const titleColorVariants = {
  gray: "group-hover:text-primary-500",
  amber: "group-hover:text-amber-800",
  teal: "group-hover:text-teal-800",
  sky: "group-hover:text-sky-800",
  purple: "group-hover:text-purple-800",
  orange: "group-hover:text-orange-800",
};

const cardColorVariants = {
  gray: "hover:bg-primary-50 hover:border-primary-100 hover:shadow-none",
  amber: "hover:bg-amber-50 border-amber-500",
  teal: "border-teal-500 hover:bg-teal-50",
  sky: "hover:bg-sky-50 border-sky-500",
  purple: "border-purple-500 hover:bg-purple-50",
  orange: "border-orange-500 hover:bg-orange-50",
};

function Dashboard(props) {
  return (
    <div
      {...props}
      className="grid grid-cols-1 gap-3 lg:gap-6 md:grid-cols-2 lg:grid-cols-3 p-4"
    />
  );
}

const DashCard = ({
  link,
  title,
  secondary,
  icon,
  color,
  onClick,
}: {
  link?: string;
  title: string;
  secondary: string;
  icon?: IconName;
  color: Color;
  onClick?: () => void;
}) => {
  const linkProps = link
    ? {
        component: Link,
        to: link,
        // if link is external, open in new tab
        ...(link.startsWith("http") && {
          target: "_blank",
          rel: "noopener noreferrer",
        }),
      }
    : {
        component: "button",
      };

  return (
    <Card
      onClick={onClick}
      {...linkProps}
      className={cn(
        "text-left flex leading-normal transition-colors bg-white p-4 lg:p-6 hover:shadow-md group",
        cardColorVariants[color]
      )}
    >
      <div className="flex flex-1 items-start gap-4">
        {icon && (
          <div
            className={cn(
              "rounded-full w-16 h-16 flex-none flex items-center justify-center text-xl transition-colors -mt-1",
              iconColorVariants[color]
            )}
          >
            <FaIcon icon={icon} />
          </div>
        )}
        <div>
          <Type.H2
            className={cn(
              "mb-2 underline-offset-2 transition-colors group-hover:underline font-medium",
              titleColorVariants[color]
            )}
          >
            {title}
          </Type.H2>
          <Type.P className="text-neutral-500 group-hover:text-neutral-600">
            {secondary}
          </Type.P>
        </div>
      </div>
    </Card>
  );
};

Dashboard.Card = DashCard;

export default Dashboard;
